module.exports = __webpack_public_path__ + "ng.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ng.svg
// module id = 984
// module chunks = 0